export const apiParameters = {
  urlImageInter: 'http://intaiapi.catch-system.com/',
  url: 'https://devapi.catch-system.com/v1',
  urlV2: 'https://devapi.catch-system.com/v2',
  urlOnly: 'https://devapi.catch-system.com',
  urlImage: 'http://aiapi.catch-system.com/',
  instagramRedirectUri: 'https://devpanel.catch-system.com/auth/instagram/callback'
  // url: "http://localhost:8000/v1"
};
